import { Component, inject } from '@angular/core'
import { forkJoin, switchMap } from 'rxjs'

import { Hunt, HuntTemplate } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService, DIALOG_DATA } from '@hyperkit'

import { SessionService } from '@hunt/services'

import { HuntTemplateService } from '../../../shared/services/hunt-template.service'
import { HuntAPIService } from '../../services/api/hunt-api.service'

@Component({
  standalone: false,
  selector: 'archive-template-dialog',
  templateUrl: './archive-template-dialog.component.html',
  styleUrls: ['./archive-template-dialog.component.scss'],
})
export class ArchiveTemplateDialogComponent {
  dialogRef = inject(DialogRef)
  dialogService = inject(DialogService)
  huntTemplateService = inject(HuntTemplateService)
  huntService = inject(HuntAPIService)
  session = inject(SessionService)
  huntTemplate = inject<HuntTemplate>(DIALOG_DATA, { optional: true })

  public nestedArchive = false

  public onSubmit(): void {
    if (this.nestedArchive) {
      this.huntTemplateService
        .archiveTemplate(this.huntTemplate.id)
        .pipe(
          switchMap((huntTemplate: HuntTemplate) =>
            forkJoin(
              huntTemplate.hunts.map((hunt: Hunt) =>
                this.huntService.archiveHunt(hunt.id),
              ),
            ),
          ),
        )
        .subscribe({
          next: () => {
            this.session.markDirty()
            this.dialogRef.close(this.huntTemplate)
          },
          error: (err) => {
            console.error('Error archiving template or hunts:', err)
          },
        })
    } else {
      this.huntTemplateService.archiveTemplate(this.huntTemplate.id).subscribe({
        next: () => {
          this.dialogRef.close(this.huntTemplate)
        },
        error: (err) => {
          console.error('Error archiving template:', err)
        },
      })
    }
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
